module.exports = __webpack_public_path__ + "static/media/aw.a7669807.svg";